/* Joey's Houseplants theme JS — Designed & built by KAHANI | Dev: Prashanth Rathod */
(function(){
  var FREE = 75;

  /* arrives-by on PDP — nationwide shipping estimate */
  var al = document.getElementById('arrive-line'), asub = document.getElementById('arrive-sub');
  if(al){
    var now = new Date();
    function f(d){ return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}); }
    var a = new Date(now); a.setDate(a.getDate()+2);
    var b = new Date(now); b.setDate(b.getDate()+4);
    al.textContent = 'Arrives ' + f(a) + ' – ' + f(b);
    if(asub) asub.textContent = 'shipped bare-root with our arrive-safe promise';
  }

  /* scroll reveals — pre-trigger 240px before entering viewport */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:0, rootMargin:'0px 0px 240px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }

  /* mobile menu */
  var mt = document.querySelector('[data-menu-toggle]');
  if(mt) mt.addEventListener('click', function(){
    var m = document.getElementById('mobile-menu');
    var open = m.classList.toggle('open');
    mt.setAttribute('aria-expanded', open);
  });

  /* footer year */
  document.querySelectorAll('.jyr').forEach(function(el){ el.textContent = new Date().getFullYear(); });

  /* PDP: thumbs, variant pills, qty */
  document.querySelectorAll('[data-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      document.getElementById('main-img').src = btn.dataset.thumb;
    });
  });
  document.querySelectorAll('.size-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.dataset.soldout) return;
      document.querySelectorAll('.size-opt').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      var v = document.getElementById('pdp-variant'); if(v) v.value = btn.dataset.variant;
      var p = document.getElementById('pdp-price'); if(p) p.textContent = btn.dataset.price;
    });
  });
  var qty = 1;
  document.querySelectorAll('[data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      qty = Math.min(9, Math.max(1, qty + parseInt(btn.dataset.qty,10)));
      var o = document.getElementById('qty-out'); if(o) o.textContent = qty;
      var i = document.getElementById('pdp-qty'); if(i) i.value = qty;
    });
  });
  var giftCb = document.getElementById('gift-cb');
  if(giftCb) giftCb.addEventListener('change', function(){
    document.getElementById('gift-note-field').style.display = this.checked ? 'block' : 'none';
  });

  /* ---------- CART DRAWER (Shopify AJAX) ---------- */
  var overlay = document.getElementById('jc-overlay');
  var drawer = document.getElementById('jc-drawer');
  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/,''); }
  function openDrawer(){ refresh().then(function(){ overlay.classList.add('open'); drawer.classList.add('open'); }); }
  function closeDrawer(){ overlay.classList.remove('open'); drawer.classList.remove('open'); }
  if(overlay) overlay.addEventListener('click', closeDrawer);
  var jcClose = document.getElementById('jc-close');
  if(jcClose) jcClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });

  /* cross-sell: one recommendation in the drawer */
  function upsell(cart){
    var box = document.getElementById('jc-upsell');
    if(!box) return;
    if(!cart.items.length){ box.innerHTML = ''; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function(i){ return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var p = (d.products || []).filter(function(x){ return inCart.indexOf(x.id) < 0 && x.available; })[0];
        if(!p){ box.innerHTML = ''; return; }
        box.innerHTML = '<div class="jc-up-h">Goes well with it</div>' +
          '<div class="jc-item"><img src="' + (p.featured_image || '') + '" alt=""><div><div class="n">' + p.title + '</div>' +
          '<div class="v">' + money(p.price) + '</div></div>' +
          '<button class="jc-up-add" type="button">Add</button></div>';
        box.querySelector('.jc-up-add').addEventListener('click', function(){
          this.disabled = true;
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id: p.variants[0].id, quantity: 1})})
            .then(function(r){ return r.json(); }).then(refresh);
        });
      }).catch(function(){ box.innerHTML = ''; });
  }

  function render(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    var ship = document.getElementById('jc-ship'), items = document.getElementById('jc-items');
    if(!ship) return;
    var sub = cart.total_price;
    var freeCents = FREE * 100;
    if(sub >= freeCents){ ship.innerHTML = 'You’ve unlocked free nationwide shipping!<div id="jc-bar"><i style="width:100%"></i></div>'; }
    else { ship.innerHTML = money(freeCents - sub) + ' away from free nationwide shipping<div id="jc-bar"><i style="width:' + Math.round(sub/freeCents*100) + '%"></i></div>'; }
    if(!cart.items.length){
      items.innerHTML = '<div id="jc-empty">Your cart is empty.<br>Your future jungle disagrees.</div>';
    } else {
      items.innerHTML = cart.items.map(function(i, idx){
        return '<div class="jc-item"><img src="' + (i.image || '') + '&width=120" alt=""><div><div class="n">' + i.product_title + '</div>' +
          (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="v">' + i.variant_title + '</div>' : '') +
          '<div class="jc-qty"><button data-line="' + (idx+1) + '" data-d="-1">−</button><span>' + i.quantity + '</span><button data-line="' + (idx+1) + '" data-d="1">+</button></div></div>' +
          '<div class="p">' + money(i.final_line_price) + '</div></div>';
      }).join('');
      items.querySelectorAll('[data-line]').forEach(function(b){
        b.addEventListener('click', function(){
          var line = parseInt(b.dataset.line,10);
          var item = cart.items[line-1];
          var q = item.quantity + parseInt(b.dataset.d,10);
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,q)})})
            .then(function(r){ return r.json(); }).then(render);
        });
      });
    }
    var co = document.getElementById('jc-checkout');
    if(co) co.textContent = cart.items.length ? 'Checkout — ' + money(sub) : 'Checkout';
    upsell(cart);
  }
  function refresh(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }
  refresh();

  /* gift note -> cart attribute */
  var gcb = document.getElementById('jc-gift-cb');
  if(gcb){
    gcb.addEventListener('change', function(){ document.getElementById('jc-gift-txt').style.display = this.checked ? 'block' : 'none'; });
    document.getElementById('jc-gift-txt').addEventListener('change', function(){
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Gift note': this.value}})});
    });
  }

  /* quick add buttons */
  document.querySelectorAll('[data-add-variant]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id: parseInt(btn.dataset.addVariant,10), quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(){ btn.disabled = false; openDrawer(); });
    });
  });

  /* PDP add-to-cart via AJAX */
  var pdpForm = document.getElementById('pdp-form');
  if(pdpForm){
    pdpForm.addEventListener('submit', function(e){
      if(e.submitter && e.submitter.classList.contains('atc')){
        e.preventDefault();
        var fd = new FormData(pdpForm);
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ return r.json(); }).then(function(){ openDrawer(); });
      }
    });
  }
})();
